module.exports = __webpack_public_path__ + "static/media/ticket.218b67b7.jpg";